import React, {useEffect} from 'react'
import './Good.css';
import AOS from "aos";
import "aos/dist/aos.css";

const Good = () => {

 useEffect(() =>{
  AOS.init({
    duration: 1000,
    easing: "ease",
  })
 })

  return (
    <>
      <div className='container-city w-full flex justify-center items-center flex-col uppercase text-center px-6 lg:mt-24 sm:mt-12 gap-5'>
        <p className='lg:text-9xl md:text-9xl sm:text-5xl'>good city</p>
        <p
          data-aos='fade-up'
          className='font-border lg:text-9xl md:text-9xl sm:text-5xl'
        >
         MOENDOE 1902
        </p>
        <p
          data-aos='fade-up'
          className=' lg:text-4xl md:text-4xl sm:text-2xl'
        >
          Kenali kami lebih dekat dengan mengikuti kegiatan kami,
        </p>
      </div>
    </>
  );
}

export default Good
